export default "__VITE_ASSET__CjFT3gDL__"